import { Component, NgZone, ViewChild } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

import { ModalShare } from './../../components/modal-share/modal-share';
import { State } from './../../providers/state';

import { DirectionsMapDirective } from '../../map/google-map.directive';

declare var google: any;
declare var gmaps: any;
@Component({
  selector: 'page-page2',
  templateUrl: 'detallCarrer.html'
})
export class DetallCarrer {
  lat: number;
  lng: number;
  public origin: Object;
  public destination: Object;
  public location: any = {
    "OBJECTID": "",
    "Poligon": "",
    "Adreça_ubi": "",
    "Tipologia": "",
    "Sup_interv": "",
    "Superf_m2": "",
    "Règim_prop": "",
    "Disponibil": "",
    "Empresa_Im": "",
    "Tl_1contac": "",
    "Tl_2contac": "",
    "E_mail": "",
    "Contacte": "",
    "Descripció": "",
    "foto": "",
    "web_immob": "",
    "geo": {
      "lat": 42.004662299769926,
      "lng": 2.299245704325995
    }
  };
  public active: boolean;
  public calcularTempsPeu: boolean = false;
  public calcularTempsCotxe: boolean = false;
  public recorreguTempsPeu: any;
  public recorreguTempsCotxe: any;
  public locations: any = [];
  public OBJECTID: any;
  public starClass: string = (this.active) ? "active" : "nactive";
  public preFiximgurl: string = "https://res.cloudinary.com/mei/image/fetch/w_300,h_300,c_thumb/";

  @ViewChild(DirectionsMapDirective) vc: DirectionsMapDirective;

  constructor(public navCtrl: NavController, public navParams: NavParams, public state: State, private zone:NgZone,) {
    this.OBJECTID = this.navParams.get("OBJECTID");
  }

  ngOnInit(){
    this.loadArray();
  }

  ionViewWillEnter() {
    this.loadArray();
  }

  goBack() {
    this.navCtrl.pop();
  }

  definirGeo() {
    this.lat = this.location.geo.lat;
    this.lng = this.location.geo.lng;
  }

  comprobarNau() {
    this.active = (!this.state.comprovaImmobleExistent(this.location.OBJECTID)) ? true : false;
    this.starClass = (this.active) ? "active" : "nactive";
  }

  openShare(){
    this.navCtrl.push(
      ModalShare, 
      {'OBJECTID': this.OBJECTID,
      'nomNau': this.location.Adreça_ubi
    });
  }

  setImmoble(id) {
    this.active = !this.active;
    if (this.active) {
      this.state.setImmoble(id);
    } else {
      this.state.deleteImmoble(id);
    }
    this.starClass = (this.active) ? "active" : "nactive";
  }

  calcularRuta() {
    this.calcularTempsPeu = true;
    this.destination = { latitude: this.lat, longitude: this.lng };
    navigator.geolocation.getCurrentPosition((position) => {
      this.origin = { latitude: position.coords.latitude, longitude: position.coords.longitude };
      this.vc.origin = this.origin;
      this.vc.metode = "WALKING";
      this.vc.destination = this.destination;
      this.vc.directionsDisplay = new google.maps.DirectionsRenderer;
      this.vc.updateDirections();
    });
  }

  calcularRuta2() {
      this.calcularTempsCotxe = true;
      this.destination = { latitude: this.lat, longitude: this.lng };
      navigator.geolocation.getCurrentPosition((position) => {
        this.origin = { latitude: position.coords.latitude, longitude: position.coords.longitude };
        this.vc.origin = this.origin;
        this.vc.metode = "DRIVING";
        this.vc.destination = this.destination;
        this.vc.directionsDisplay = new google.maps.DirectionsRenderer;
        this.vc.updateDirections();
      });
    }

  public setTime(event) {
    if (event.method === "WALKING"){
      this.recorreguTempsPeu = event.value;
    }else if(event.method === "DRIVING"){
      this.recorreguTempsCotxe = event.value;
    }
  }

  public getCurrentCarrer() {
    this.location = this.locations.find(location => {
      return location.OBJECTID === parseInt(this.OBJECTID);
    });
  }

  loadArray() {
    let style = {
      fillColor: '#333388',
      fillOpacity: 0.35,
      strokeColor: '#FFFFFF',
      strokeWeight: 1,
      strokeOpacity: 1,
      zIndex: 0
    };

    let url = 'https://services.arcgis.com/WNsrZDHEJ88NE4N8/ArcGIS/rest/services/Espais_lliures_polígons/FeatureServer/0';
    let layer = new gmaps.ags.Layer(url);
    let params = {
      returnGeometry: true,
      where: "1 = 1",
      outFields: ["OBJECTID", "Poligon", "Adreça_ubi", "Tipologia", "Sup_interv", "Superf_m2", "Règim_prop", "Disponibil", "Empresa_Im", "Tl_1contac", "Tl_2contac", "E_mail", "Contacte", "Descripció", "foto", "web_immob"],
      overlayOptions: style
    };
    layer.query(params, (rs) => {
      rs.features.forEach(element => this.setupFeature(element));
      this.getCurrentCarrer();
      this.definirGeo();
      this.comprobarNau();
      this.zone.run(() => {});
    });

  }

  setupFeature(feat) {
    if (feat.geometry != undefined) {
      let g = feat.geometry[0];//V3 supports multiple rings, so should have only 1 element

      feat.attributes["geo"] = this.getPolyCenter(g);
      this.locations.push(feat.attributes);
    }
  }

  getPolyCenter(poly) {
    let lat = 0;
    let lng = 0;
    let c = 0;
    let paths = poly.getPaths();
    for (var j = 0, jc = paths.getLength(); j < jc; j++) {
      let path = paths.getAt(j);
      for (var k = 0, kc = path.getLength(); k < kc; k++) {
        let latlng = path.getAt(k);
        lat += latlng.lat();
        lng += latlng.lng();
        c++;
      }
    }
    return c > 0 ? { "lat": lat / c, "lng": lng / c } : null;
  }

}



// WEBPACK FOOTER //
// ./src/pages/detallCarrer/detallCarrer.ts